<script lang="ts">
	import type { Glob } from '$content';

	export let metadata: Glob['metadata'];
	export let context;
</script>

<svelte:head>
	<title>{metadata.title} | {context.title}</title>
	<meta name="description" content={metadata.og.description} />
	<meta property="og:title" content={metadata.og.title} />
	<meta property="og:description" content={metadata.og.description} />
	<meta property="og:url" content={context.og.url} />
	<meta property="og:type" content="website" />
	<meta property="og:image" content={context.og.image.url} />
	<meta property="og:image:alt" content={context.og.image.alt} />
	<meta property="og:image:type" content={context.og.image.type} />
	<meta property="og:image:width" content={context.og.image.width} />
	<meta property="og:image:height" content={context.og.image.height} />
	<meta name="twitter:title" content={metadata.og.title} />
	<meta name="twitter:description" content={metadata.og.description} />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:image" content={context.og.image.url} />
	<meta name="twitter:image:alt" content={context.og.image.alt} />
	<meta
		property="og:article:published_time"
		content={new Date(metadata.published_time).toISOString()}
	/>
</svelte:head>

<main class="mt-10 max-w-screen-lg mx-auto px-4">
	<div class="prose">
		<slot />
	</div>
</main>
